import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, Form, Upload } from "antd";
import "./style.css";
import Global from "../../../../Global";
import { getAllProjectFilesAction } from "../../store/actions";

const serverUrl =
    process.env.NODE_ENV === "development"
        ? `${Global.SERVER_API_URL}/api`
        : `${window.location.origin}/api`;

const projectImgsEnum = {
    1: "mainImage",
    2: "image",
    3: "drawing",
    4: "explication",
    5: "resources"
};

const EditProjectFiles = ({ projectId, form, deletedFiles, setDeletedFiles, formChange }) => {
    const { t } = useTranslation(["action", "project"]);
    const dispatch = useDispatch();

    const { projectFiles, changedImages } = useSelector((state) => state.projectReducer);

    const getProjectFiles = () => {
        dispatch(getAllProjectFilesAction({ AnalogProjectId: projectId }));
    };

    useEffect(() => {
        getProjectFiles();
    }, []);

    useEffect(() => {
        if (projectFiles?.length) {
            form.setFieldsValue(
                Object.fromEntries(
                    projectFiles.map((file) => [
                        projectImgsEnum[file.funcType],
                        file.files.map((f) => {
                            return {
                                ...f,
                                url: `${serverUrl}/JsonLine/downloadObjectFileByFileId?id=${f.uid}`,
                            };
                        }),
                    ])
                )
            );
        }
    }, [projectFiles]);

    useEffect(() => {
        if (changedImages) {
            setDeletedFiles([]);
        }
    }, [changedImages]);

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    const deleteFile = (file) => {
        if (!file.originFileObj) {
            setDeletedFiles([...deletedFiles, file.uid]);
        }
    };

    return (
        <div className="edit-project-files">
            <Form
                layout="horizontal"
                autoComplete="off"
                form={form}
                className="edit-project-files-form"
                name="projectEditFormFiles"
                onValuesChange={formChange}
            >
                {Object.entries(projectImgsEnum).map(([_, value]) => (
                    <div className="img">
                        <p>{t(`project:projectImgTitles.${value}`)}</p>
                        <div className="upload">
                            <Form.Item
                                valuePropName="fileList"
                                getValueFromEvent={normFile}
                                name={value}
                                className="project-upload-img"
                            >
                                <Upload
                                    beforeUpload={() => false}
                                    onPreview={() => false}
                                    onRemove={deleteFile}
                                    maxCount={
                                        value === projectImgsEnum[1] ? 1 : false
                                    }
                                    multiple={value !== projectImgsEnum[1]}
                                    listType="picture-card"
                                    accept=".jpeg,.jpg,.raw,.tiff,.psd,.bmp,.gif,.png,.jp2"
                                >
                                    <Button className="btn">
                                        {t("action:add")}
                                    </Button>
                                </Upload>
                            </Form.Item>
                        </div>
                    </div>
                ))}
            </Form>
        </div>
    );
};

export default EditProjectFiles;
